var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shopping-cart"},[_c('cart-items',{attrs:{"actionText":"Continue Shopping","showCheckout":true,"lineActions":_vm.lineActions},on:{"handleAction":function($event){return _vm.$router.push({ name: 'catalog' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }